import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { prepareHeaders } from "../user/user.api";
import { PaginationResults, TypeQuery } from "../user/user.type";
import { DesignationFormdata, IDesignation } from "./designation.type";
import { ApiBaseUrl } from "../../http";


const DesignationApi = createApi({
  reducerPath: "designationApi",
  tagTypes: ["designation"],
  baseQuery: fetchBaseQuery({
    baseUrl: `${ApiBaseUrl}/api/`,
    prepareHeaders,
  }),
  endpoints: (build) => ({
    addDesignation: build.mutation<IDesignation,{ slug?: string; data: IDesignation }>({
      query: ({ slug, data }) => ({
        url: slug ? `designations/${slug}/` : `designations/`,
        method: slug ? "PUT" : "POST",
        body: data,
      }),
      invalidatesTags: ["designation"],
    }),
    getDesignations: build.query<PaginationResults<IDesignation>, TypeQuery>({
      query: () => `designations/`,
      providesTags: ["designation"],
    }),
    deleteDesignation: build.mutation<DesignationFormdata, string>({
      query: (slug) => ({
        url: `designations/${slug}/`,
        method: "DELETE",
      }),
      invalidatesTags: ["designation"],
    }),
  }),
});

export default DesignationApi

export const {
  useAddDesignationMutation,
  useGetDesignationsQuery,
  useDeleteDesignationMutation,
} = DesignationApi;